import styled from '@emotion/styled';
import PortfolioSectionName from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemFields/Section/SectionName';

const SectionName = styled(PortfolioSectionName)({
  marginBottom: 0,
  marginRight: 'auto',
});

export default SectionName;
